import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import Modal from "../modal";
import applyDiscount from "../../utils/apply-discount";
import { notifyMobileApp } from "../../utils/biling-util";

const {
  STRIPE: { PRICES },
} = require("../../constants");

function UpgradeConfirmationModal(props, { locals }) {
  const { activeUser, momentTZ, query, activeUserToRequest } = locals;
  const planChange = get(query, "change", false);
  const coupon = get(activeUserToRequest, "stripe.coupon");

  let plan, price;
  switch (activeUserToRequest.stripe.plan) {
    case "launch_twelveMonth":
      plan = "Twelve Month Subscription";
      price = PRICES.twelveMonths;
      break;
    case "launch_threeMonth":
      plan = "Three Month Subscription";
      price = PRICES.threeMonths;
      break;
    case "launch_oneMonth":
      plan = "Monthly Subscription";
      price = PRICES.oneMonth;
      break;
    case "v2_premium_monthly":
      plan = "Premium Monthly Subscription";
      price = PRICES.v2_premium_monthly;
      break;
    case "v2_premium_annually":
      plan = "Premium Annual Subscription";
      price = PRICES.v2_premium_annually;
      break;
    case "v2_standard_monthly":
      plan = "Standard Monthly Subscription";
      price = PRICES.v2_standard_monthly;
      break;
    case "v2_standard_annually":
      plan = "Standard Annual Subscription";
      price = PRICES.v2_standard_annually;
      break;
    default:
  }

  return (
    <Modal width="600px">
      <div className="head">
        <h2 className="alt">Upgrade Confirmation</h2>
      </div>

      <div className="body">
        <div className="column" data-col="1/1">
          <p>Congratulations {activeUser.name}!</p>
          <p>
            You have successfully upgraded your account to the <b>{plan}</b>.
            Your payment of{" "}
            <b>${`${applyDiscount(price, coupon).toFixed(2)}`}</b> was confirmed
            and your account is valid through to{" "}
            <b>{`${momentTZ(activeUserToRequest.stripe.period_end).format(
              "MMM. DD, YYYY"
            )}`}</b>
            .
          </p>
          <p>Your subscription will renew at the end of the billing cycle.</p>
        </div>
      </div>

      <div className="foot">
        <a
          className="button"
          onClick={() => notifyMobileApp()}
          href="/dashboard/settings/subscription"
        >
          Close
        </a>
      </div>
    </Modal>
  );
}

UpgradeConfirmationModal.contextTypes = { locals: PropTypes.object };

export default UpgradeConfirmationModal;
